import {
  COUNCIL_REPORT_MANIFEST,
  COUNCIL_REPORT_MANIFEST_VALIDATION,
  type DftRatingValue,
} from '@fixtyer/content';

export interface AuthorityRating {
  id: string;
  name: string;
  region: string;
  dftOverallRating: DftRatingValue;
  dftConditionRating: DftRatingValue;
  dftSpendRating: DftRatingValue;
  dftBestPracticeRating: DftRatingValue;
  dftRatingYear: '2025-2026';
}

export interface AuthorityLeagueTable {
  authorities: AuthorityRating[];
  stats: { total: number; green: number; amber: number; red: number };
  regions: string[];
  ratingYear: '2025-2026';
}

const authorities: AuthorityRating[] = COUNCIL_REPORT_MANIFEST
  .map((authority) => ({
    id: authority.authorityId,
    name: authority.canonicalName,
    region: authority.region,
    dftOverallRating: authority.ratings.overall,
    dftConditionRating: authority.ratings.condition,
    dftSpendRating: authority.ratings.spend,
    dftBestPracticeRating: authority.ratings.bestPractice,
    dftRatingYear: authority.ratingPeriod,
  }))
  .sort((a, b) => a.name.localeCompare(b.name, 'en'));

export const STATIC_AUTHORITY_LEAGUE_TABLE: AuthorityLeagueTable = {
  authorities,
  stats: {
    total: authorities.length,
    green: authorities.filter(({ dftOverallRating }) => dftOverallRating === 'green').length,
    amber: authorities.filter(({ dftOverallRating }) => dftOverallRating === 'amber').length,
    red: authorities.filter(({ dftOverallRating }) => dftOverallRating === 'red').length,
  },
  regions: [...new Set(authorities.map((authority) => authority.region))].sort((a, b) =>
    a.localeCompare(b, 'en')
  ),
  ratingYear: '2025-2026',
};

if (STATIC_AUTHORITY_LEAGUE_TABLE.stats.total !== COUNCIL_REPORT_MANIFEST_VALIDATION.authorities) {
  throw new Error('Authority league table drifted from the council report manifest');
}
